import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { DropdownList } from '../components/formControls';
import { withNamespaces } from 'react-i18next';

class TimeZonePicker extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	handleSelectChange(timeZoneName) {
		const { onChange } = this.props;

		if (onChange) {
			onChange(timeZoneName);
		}
	}

	renderListItem({ item }) {
		return <div>
			<div style={{ fontSize: '14px' }}>{item.displayName}</div>
			<div>{item.name} (GMT{item.offset})</div>
			<div style={{ color: '#999999' }}>{item.country}</div>
		</div>;
	}

	renderSelectedItem({ item }) {
		return <span>{item.displayName} - {item.name} (GMT{item.offset})</span>;
	}

	render() {
		const { name = 'timeZone', placeholder, timeZones, emptyValue, t, ...rest } = this.props;

		return <Field name={name} component={DropdownList}
			options={timeZones} valueField='name' textField={item => `${item.displayName} ${item.name} ${item.country} ${item.countryCode}`}	// search in all fields
			filter='contains' 
			//groupBy='countryName'
			itemComponent={this.renderListItem}
			valueComponent={this.renderSelectedItem}
			onChange={this.handleSelectChange}
			{...rest}
		/>;
	}
}

TimeZonePicker.propTypes = {
	timeZones: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string,
		displayName: PropTypes.string,
		countryCode: PropTypes.string,
		country: PropTypes.string,
		offset: PropTypes.string
	}))
};

export default withNamespaces()(TimeZonePicker);